import Location from './Location'

export default Location
// eslint-disable-next-line import/export
export * from './Location'
